import type { IEquipmentItem } from '@shared/types';

import { TRAINER_MODELS } from './trainer-models';

export const SPORT_PLATFORMS_ITEMS: IEquipmentItem[] = [
  {
    id: 'spl-01',
    categorySlug: 'sport-platforms',
    number: '01',
    title: 'Скамья двойная',
    description:
      'Две горизонтальные скамьи разной высоты для упражнений с собственным весом. Подходят для отжиманий с опорой на край скамьи и упражнений на мышцы плечевого пояса.',
    photos: ['/equipment/sport-platforms/1. Скамья двойная.webp'],
    videoUrl: 'https://rutube.ru/play/embed/5290dc94068463025bae133f8aff1edc',
    videoTitle: 'Обратные отжимания от скамьи',
    specs: [
      { label: 'Длина', value: '1 800 мм' },
      { label: 'Высота', value: '450 мм' },
      { label: 'Планки', value: 'Сталь 40×20 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '300 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Сгибание и разгибание рук в упоре сзади о скамью',
        inVideo: true,
        start:
          'Сядьте на край скамьи, упритесь в него ладонями по бокам от таза, пальцами вперёд. Сместите таз вперёд со скамьи, ноги вытяните и обопритесь на пятки.',
        steps: [
          'Согните руки, опуская таз вниз вдоль скамьи; спина остаётся близко к краю.',
          'Выпрямите руки, поднимая корпус в исходное положение.',
        ],
        tips: [
          'Опускайтесь неглубоко, сохраняя контроль движения. При дискомфорте в плечах прекратите упражнение.',
          'Чтобы облегчить упражнение, согните ноги в коленях и поставьте стопы ближе к скамье.',
        ],
      },
      {
        title: 'Сгибание и разгибание рук в упоре о скамью',
        start:
          'Встаньте лицом к скамье, упритесь ладонями в её край на ширине плеч и отведите ноги назад: корпус и ноги — одна прямая линия.',
        steps: [
          'Согните руки, опуская грудь к краю скамьи.',
          'Выпрямите руки, сохраняя прямую линию корпуса.',
        ],
        tips: [
          'Чем выше опора, тем легче упражнение — начинайте с высокой скамьи.',
          'Не прогибайтесь в пояснице и не поднимайте таз.',
        ],
      },
      {
        title: 'Шаги на скамью',
        start: 'Встаньте лицом к низкой скамье, стопы на ширине таза.',
        steps: [
          'Поставьте одну стопу на скамью целиком.',
          'Поднимитесь, перенося вес на эту ногу, и приставьте вторую.',
          'Сойдите назад той же ногой, с которой начинали, и смените ногу.',
        ],
        tips: [
          'Ставьте стопу на скамью полностью, не на носок.',
          'Спина ровная, небольшой наклон корпуса вперёд допустим; колено движется в направлении носка.',
        ],
      },
    ],
    safetyNote: 'Не выполняйте упражнения на мокрой или обледенелой скамье.',
  },
  {
    id: 'spl-02',
    categorySlug: 'sport-platforms',
    number: '02',
    title: 'Скамья пресс',
    description:
      'Гимнастическая скамья с упором для стоп для подъёма туловища из положения лёжа. Используется для упражнений на мышцы живота и контроля положения корпуса.',
    photos: ['/equipment/sport-platforms/2. Скамья пресс.webp'],
    videoUrl: 'https://rutube.ru/play/embed/08f7868d810d8507ef47eca5570b9687',
    videoTitle: 'Подъём туловища на скамье',
    specs: [
      { label: 'Длина', value: '1 400 мм' },
      { label: 'Высота', value: '450 мм' },
      { label: 'Диаметр трубы', value: '48 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Поднимание туловища из положения лёжа на спине',
        inVideo: true,
        start:
          'Сядьте на скамью, заведите стопы под упор, лягте на спину. Ноги согнуты в коленях, руки за головой или скрещены на груди.',
        steps: [
          'Поднимите туловище усилием мышц живота до положения сидя.',
          'Плавно опуститесь, пока лопатки не коснутся скамьи.',
        ],
        tips: ['Не помогайте себе рывком корпуса и руками.', 'Дышите ровно: выдох — на подъёме.'],
      },
      {
        title: 'Скручивания',
        start: 'Лёжа на скамье, стопы под упором, ноги согнуты, руки скрещены на груди.',
        steps: [
          'Приподнимите голову и лопатки, сокращая мышцы живота; поясница остаётся на скамье.',
          'Задержитесь на мгновение и медленно опуститесь.',
        ],
        tips: ['Подходит для начала, если полный подъём туловища пока даётся тяжело.'],
      },
    ],
    safetyNote: 'Не тяните голову руками и не прижимайте подбородок к груди.',
  },
  {
    id: 'spl-03',
    categorySlug: 'sport-platforms',
    number: '03',
    title: 'Скамья с линейками',
    description:
      'Гимнастическая скамья с измерительными линейками для наклона вперёд из положения стоя. Линейки позволяют отметить достигнутое положение пальцев во время упражнения на гибкость.',
    photos: ['/equipment/sport-platforms/3. Скамья с линейками.webp'],
    videoUrl: 'https://rutube.ru/play/embed/efd761808f90d969db5e8b1a0c686670',
    videoTitle: 'Наклон вперёд стоя на скамье',
    specs: [
      { label: 'Длина', value: '600 мм' },
      { label: 'Высота', value: '320 мм' },
      { label: 'Шкала', value: 'Нанесена краской, -30…+50 см' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Наклон вперёд из положения стоя на скамье',
        inVideo: true,
        start:
          'Встаньте на скамью у измерительной шкалы: стопы параллельно, носки у края, ноги выпрямлены.',
        steps: [
          'Медленно наклонитесь вперёд, опуская пальцы рук вдоль линейки.',
          'Ненадолго задержитесь в нижней точке.',
          'Запомните отметку на шкале и плавно выпрямитесь.',
        ],
        tips: ['Колени не сгибайте.', 'Перед наклоном разомните спину и заднюю поверхность бедра.'],
      },
    ],
    safetyNote:
      'Не пружиньте и не просите другого человека усилить наклон. При неприятных ощущениях прекратите упражнение.',
  },
  {
    id: 'spl-04',
    categorySlug: 'sport-platforms',
    number: '04',
    title: 'Стенд',
    description:
      'Информационный стенд для схем площадки, правил пользования оборудованием и описаний упражнений. Помогает посетителю выбрать снаряд и ознакомиться с порядком занятия.',
    photos: ['/equipment/sport-platforms/4. Стенд.webp'],
    specs: [
      { label: 'Размер щита', value: '600 × 900 мм' },
      { label: 'Высота стойки', value: '1 800 мм' },
      { label: 'Материал', value: 'Ст3, ПВХ-накладка' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Гарантия', value: '5 лет' },
    ],
  },
  {
    id: 'spl-05',
    categorySlug: 'sport-platforms',
    number: '05',
    title: 'Прыжок в длину с места',
    description:
      'Размеченная зона для прыжка в длину с места толчком двумя ногами. Позволяет выполнить прыжок и определить расстояние по шкале площадки.',
    photos: ['/equipment/sport-platforms/5. Прыжок в длину с места.webp'],
    videoUrl: 'https://rutube.ru/play/embed/e9fcc7a96110a888d291d3a0eb1cadd7',
    videoTitle: 'Прыжок в длину с места',
    specs: [
      { label: 'Длина', value: '3 000 мм' },
      { label: 'Ширина', value: '600 мм' },
      { label: 'Покрытие', value: 'Резиновое, нескользящее' },
      { label: 'Материал рамы', value: 'Ст3, порошковое окрашивание' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Прыжок в длину с места толчком двумя ногами',
        inVideo: true,
        start: 'Встаньте у стартовой линии, не заступая за неё, стопы на ширине плеч.',
        steps: [
          'Согните ноги и отведите руки назад.',
          'Оттолкнитесь двумя ногами одновременно, выбросив руки вперёд.',
          'Приземлитесь на обе ноги, мягко сгибая колени, и удержите равновесие.',
          'Результат — по разметке у ближайшей к старту точки касания.',
        ],
        tips: [
          'Перед прыжками разомните голеностопы и колени.',
          'Старайтесь удержать равновесие после приземления. Если коснулись покрытия позади пяток, результат измеряется до этой точки.',
        ],
      },
    ],
    safetyNote: 'Прыгайте, только когда зона приземления свободна.',
  },
  {
    id: 'spl-06',
    categorySlug: 'sport-platforms',
    number: '06',
    title: 'Рывок гири',
    description:
      'Оборудованная зона со стойкой для гирь для выполнения рывка и подготовки к этому упражнению. Предназначена для силовой работы с контролируемым подъёмом гири над головой.',
    photos: ['/equipment/sport-platforms/6. Рывок гири.webp'],
    specs: [
      { label: 'Высота', value: '1 200 мм' },
      { label: 'Диаметр трубы', value: '60 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '100 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/9993d161fd14bc97ed2d9ec5cb2c3b08',
    videoTitle: 'Рывок гири',
    exercises: [
      {
        title: 'Рывок гири',
        inVideo: true,
        start: 'Гиря стоит на покрытии между стоп, стопы на ширине плеч.',
        steps: [
          'Наклонитесь с прямой спиной и возьмите рукоять одной рукой.',
          'Качните гирю назад между ног, затем разогните ноги и таз, направляя гирю вверх близко к телу.',
          'Подведите кисть под рукоять, чтобы гиря мягко легла на предплечье, и зафиксируйте её на прямой руке над головой.',
          'Контролируемо направьте гирю вниз и назад между ног, отводя таз назад, и повторите; руку меняйте после подхода.',
        ],
        tips: [
          'Технику осваивайте с инструктором и с лёгкой гирей.',
          'Спина всё время прямая, гирю поднимает работа ног и таза, а не рука.',
          'Не допускайте удара гири по предплечью и рывка в плече.',
        ],
      },
      {
        title: 'Становая тяга гири двумя руками',
        start: 'Гиря на покрытии между стоп, стопы чуть шире плеч.',
        steps: [
          'Отводя таз назад, присядьте с прямой спиной и возьмите рукоять двумя руками.',
          'Выпрямитесь за счёт ног и таза, гиря движется близко к телу.',
          'Опустите гирю тем же путём, не округляя спину.',
        ],
        tips: ['Подготовительное упражнение перед рывком: учит работать ногами и тазом.'],
      },
      {
        title: 'Приседание с гирей у груди',
        start: 'Стоя, держите гирю двумя руками за рукоять у груди, стопы чуть шире плеч.',
        steps: [
          'Присядьте, отводя таз назад; колени направлены по носкам.',
          'Встаньте, сохраняя корпус прямым.',
        ],
        tips: ['Пятки не отрываются от покрытия.'],
      },
    ],
    safetyNote:
      'Освободите пространство вокруг себя. Не бросайте гирю и не выпускайте её в сторону других посетителей.',
  },
  {
    id: 'spl-07',
    categorySlug: 'sport-platforms',
    number: '07',
    title: 'Мишень круглая',
    description:
      'Круглая мишень на стойках для упражнений на точность броска. Используется с подходящим мячом для тренировки координации и направленного метания.',
    photos: ['/equipment/sport-platforms/7. Мишень круглая.webp'],
    specs: [
      { label: 'Диаметр мишени', value: '600 мм' },
      { label: 'Высота установки', value: '2 000 мм' },
      { label: 'Толщина листа', value: '4 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/198f52be38e5b2902bb40a490b779e60',
    videoTitle: 'Метание мяча в цель',
    exercises: [
      {
        title: 'Метание теннисного мяча в цель',
        inVideo: true,
        start: 'Встаньте за линией броска лицом к мишени, мяч в бросковой руке.',
        steps: [
          'Отведите руку с мячом назад и вверх.',
          'Броском одной рукой из-за головы направьте мяч в центр мишени.',
        ],
        tips: [
          'Перед бросками разомните плечо и локоть.',
          'Смотрите на центр мишени, а не на мяч.',
        ],
      },
    ],
    safetyNote:
      'Бросайте только лёгкие мячи. Подходите к мишени за мячами, когда все закончили броски.',
  },
  {
    id: 'spl-08',
    categorySlug: 'sport-platforms',
    number: '08',
    title: 'Двойная разноуровневая скамья с линейками',
    description:
      'Разноуровневая двойная скамья с измерительными линейками для упражнений на гибкость. Предусмотрена работа с наклоном вперёд сидя и отслеживанием положения рук по шкале.',
    photos: ['/equipment/sport-platforms/8. Двойная разноуровневая скамья с линейками.webp'],
    specs: [
      { label: 'Длина', value: '600 мм' },
      { label: 'Высота уровней', value: '260 / 320 мм' },
      { label: 'Шкала', value: 'Нанесена краской, -30…+50 см' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Наклон вперёд из положения сидя',
        start:
          'Сядьте перед измерительной шкалой, выпрямите ноги и упритесь стопами в упор; руки вытянуты вперёд.',
        steps: [
          'Медленно наклонитесь вперёд, скользя пальцами вдоль шкалы.',
          'Ненадолго задержитесь в крайней точке и запомните отметку.',
          'Плавно вернитесь в исходное положение.',
        ],
        tips: ['Колени не сгибайте.', 'Перед наклоном разомните спину и заднюю поверхность бедра.'],
      },
    ],
    safetyNote: 'Не пружиньте и не просите другого человека усилить наклон.',
  },
  {
    id: 'spl-09',
    categorySlug: 'sport-platforms',
    number: '09',
    title: 'Тройной турник',
    description:
      'Три стационарные перекладины разной высоты для висов и подтягиваний. Позволяют выбрать удобный уровень хвата и выполнять упражнения с собственным весом.',
    photos: ['/equipment/sport-platforms/9. Тройной турник.webp'],
    specs: [
      { label: 'Высота перекладин', value: '1 800 / 2 100 / 2 400 мм' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Стойки', value: 'Труба 76 мм, Ст3' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/04d731014d48596136528ea70cc4b5d3',
    videoTitle: 'Подтягивания на высокой перекладине',
    exercises: [
      {
        title: 'Подтягивание из виса на высокой перекладине',
        inVideo: true,
        start:
          'Вис на перекладине хватом сверху на ширине плеч, руки и ноги прямые, ноги не касаются земли.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше перекладины.',
          'Опуститесь в вис до полного выпрямления рук.',
        ],
        tips: [
          'Без рывков, махов ногами и раскачивания.',
          'Если подтянуться пока не получается, начните с виса и подтягиваний на низкой перекладине.',
        ],
      },
      {
        title: 'Вис на перекладине',
        start:
          'Возьмитесь за перекладину хватом сверху на ширине плеч и повисните на прямых руках.',
        steps: [
          'Слегка напрягите плечи, чтобы они не уходили к ушам, ноги держите вместе.',
          'Удерживайте неподвижный вис без раскачивания.',
          'Сойдите со снаряда раньше, чем начнёт ослабевать хват.',
        ],
        tips: ['Хорошая подготовка к подтягиваниям и тренировка хвата.'],
      },
      {
        title: 'Подъём согнутых ног в висе',
        start: 'Вис на перекладине хватом сверху, ноги прямые и не касаются земли.',
        steps: [
          'Плавно поднимите согнутые колени к груди.',
          'Медленно опустите ноги в исходное положение.',
        ],
        tips: [
          'Поднимайте ноги усилием мышц живота, без маха и раскачивания.',
          'Выбирайте перекладину, на которой стопы не задевают землю.',
        ],
      },
    ],
    safetyNote: 'Сходите со снаряда спокойно, не спрыгивайте в занятую зону.',
  },
  {
    id: 'spl-10',
    categorySlug: 'sport-platforms',
    number: '10',
    title: 'Турник двойной низкий',
    description:
      'Низкие перекладины с опорами для ног для подтягивания из виса лёжа. Используются для упражнений на мышцы спины и рук с частичной опорой тела.',
    photos: ['/equipment/sport-platforms/10. Турник двойной низкий.webp'],
    specs: [
      { label: 'Высота перекладин', value: '1 000 / 1 300 мм' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/3cf584142e3e285c314f80ff08d3055c',
    videoTitle: 'Подтягивания из виса лёжа',
    exercises: [
      {
        title: 'Подтягивание из виса лёжа на низкой перекладине',
        inVideo: true,
        start:
          'Возьмитесь за перекладину хватом сверху и выйдите ногами вперёд на опору: тело прямое от плеч до пяток, руки выпрямлены.',
        steps: [
          'Подтянитесь, пока грудь не приблизится к перекладине.',
          'Опуститесь до полного выпрямления рук.',
        ],
        tips: [
          'Держите тело прямым, таз не провисает.',
          'Чем ниже перекладина, тем сложнее упражнение.',
        ],
      },
      {
        title: 'Отжимания в упоре о перекладину',
        start:
          'Встаньте лицом к перекладине, упритесь в неё ладонями на ширине плеч и отведите ноги назад: тело прямое.',
        steps: ['Согните руки, опуская грудь к перекладине.', 'Выпрямите руки.'],
        tips: ['Чем выше перекладина, тем легче упражнение.'],
      },
    ],
    safetyNote:
      'В подтягиваниях ставьте пятки на штатную опору, в отжиманиях — стопы на покрытие. Перед началом проверьте устойчивость опоры.',
  },
  {
    id: 'spl-11',
    categorySlug: 'sport-platforms',
    number: '11',
    title: 'Помост',
    description:
      'Гимнастический помост для сгибания и разгибания рук в упоре лёжа. Ровная площадка и контактный ограничитель помогают контролировать выполнение упражнения.',
    photos: ['/equipment/sport-platforms/11. Помост.webp'],
    specs: [
      { label: 'Габариты', value: '1 200 × 1 200 мм' },
      { label: 'Высота', value: '250 мм' },
      { label: 'Поверхность', value: 'Рифлёный лист, нескользящий' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '500 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/5308f68e6d6d3440078867985e22d503',
    videoTitle: 'Отжимания на помосте',
    exercises: [
      {
        title: 'Сгибание и разгибание рук в упоре лёжа',
        inVideo: true,
        start: 'Примите упор лёжа на помосте: руки на ширине плеч, тело прямое от плеч до пяток.',
        steps: [
          'Согните руки и коснитесь грудью контактной платформы.',
          'Выпрямите руки полностью.',
        ],
        tips: [
          'Не прогибайтесь в пояснице и не поднимайте таз.',
          'Если полное отжимание пока не получается, начните с отжиманий в упоре о скамью.',
        ],
      },
    ],
    safetyNote: 'Контактная платформа — для касания грудью, не опирайтесь на неё всем весом.',
  },
  {
    id: 'spl-12',
    categorySlug: 'sport-platforms',
    number: '12',
    title: 'Турник регулируемый',
    description:
      'Турник с изменяемой высотой перекладины для подтягиваний из виса и облегчённых упражнений с опорой ног. Высота подбирается до начала занятия.',
    photos: ['/equipment/sport-platforms/12. Турник регулируемый.webp'],
    specs: [
      { label: 'Диапазон высот', value: '1 600–2 400 мм' },
      { label: 'Шаг регулировки', value: '100 мм' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/dbb0c81e666735cb255ae553695cd2b7',
    videoTitle: 'Подтягивания на высокой и низкой перекладинах',
    exercises: [
      {
        title: 'Подтягивание из виса на высокой перекладине',
        inVideo: true,
        start:
          'Установите перекладину в верхнее положение. Вис хватом сверху на ширине плеч, руки и ноги прямые.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше перекладины.',
          'Опуститесь в вис до полного выпрямления рук.',
        ],
        tips: ['Без рывков, махов ногами и раскачивания.'],
      },
      {
        title: 'Подтягивание из виса лёжа на низкой перекладине',
        inVideo: true,
        start:
          'Установите и зафиксируйте перекладину в нижнем положении. Возьмитесь хватом сверху, расположитесь под перекладиной и поставьте пятки на опору; тело прямое от плеч до пяток, руки выпрямлены.',
        steps: [
          'Подтянитесь, пока грудь не приблизится к перекладине.',
          'Опуститесь до полного выпрямления рук.',
        ],
        tips: ['Держите тело прямым, таз не провисает.'],
      },
    ],
    safetyNote:
      'Меняйте высоту перекладины только без нагрузки и проверяйте фиксацию перед упражнением.',
  },
  {
    id: 'spl-13',
    categorySlug: 'sport-platforms',
    number: '13',
    title: 'Брусья двойные',
    description:
      'Параллельные брусья для упоров и отжиманий с собственным весом. Разные участки конструкции позволяют выбрать удобное положение рук и высоту опоры.',
    photos: ['/equipment/sport-platforms/13. Брусья двойные.webp'],
    videoUrl: 'https://rutube.ru/play/embed/b08b6191574761e77f6532571654a84c',
    videoTitle: 'Отжимания на брусьях',
    specs: [
      { label: 'Высота', value: '100 / 160 см' },
      { label: 'Ширина', value: '58 см' },
      { label: 'Диаметр трубы', value: '48 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '200 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Отжимания на брусьях',
        inVideo: true,
        start:
          'Упор на прямых руках на высоких брусьях, корпус вертикально, ноги не касаются земли.',
        steps: [
          'Согните руки, опуская корпус, пока плечо не окажется примерно на уровне локтя.',
          'Выпрямите руки, поднимая корпус в упор.',
        ],
        tips: [
          'Не опускайтесь глубже, чем позволяет подвижность плеч.',
          'Без раскачивания и рывков.',
        ],
      },
      {
        title: 'Удержание упора на брусьях',
        start: 'Упор на прямых руках, корпус вертикально.',
        steps: [
          'Опустите плечи вниз, от ушей, и удерживайте корпус неподвижно.',
          'Сойдите с брусьев раньше, чем устанут руки.',
        ],
        tips: ['Подготовка к отжиманиям на брусьях.'],
      },
      {
        title: 'Отжимания в упоре о низкие брусья',
        start:
          'Встаньте лицом к низким брусьям, упритесь ладонями в обе жерди и отведите ноги назад: тело прямое.',
        steps: ['Согните руки, опуская грудь между брусьями.', 'Выпрямите руки.'],
        tips: ['Облегчённый вариант для начинающих.'],
      },
    ],
    safetyNote: 'Перед упражнением проверьте, что брусья сухие.',
  },
  {
    id: 'spl-16',
    categorySlug: 'sport-platforms',
    number: '16',
    title: 'Разнохватовый турник',
    description:
      'Перекладина с несколькими вариантами положения кистей для висов и подтягиваний. Позволяет менять хват при упражнениях на спину и плечевой пояс.',
    photos: ['/equipment/sport-platforms/16. Разнохватовый турник.webp'],
    specs: [
      { label: 'Высота', value: '2 400 мм' },
      { label: 'Вариантов хвата', value: '4' },
      { label: 'Диаметр перекладин', value: '28–48 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/76ac1a3d3ad03dbd31c773cb3c2ef14c',
    videoTitle: 'Подтягивания разными хватами',
    exercises: [
      {
        title: 'Подтягивание широким хватом',
        inVideo: true,
        start: 'Возьмитесь за крайние рукояти хватом сверху и повисните на прямых руках.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше перекладины.',
          'Опуститесь в вис до полного выпрямления рук.',
        ],
        tips: ['Без рывков и раскачивания.'],
      },
      {
        title: 'Подтягивание средним хватом',
        inVideo: true,
        start: 'Вис на прямой перекладине хватом сверху на ширине плеч.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше перекладины.',
          'Опуститесь в вис до полного выпрямления рук.',
        ],
        tips: ['Базовый вариант — с него удобно начинать.'],
      },
      {
        title: 'Подтягивание узким хватом',
        inVideo: true,
        start:
          'Возьмитесь за средние рукояти, кисти близко друг к другу, повисните на прямых руках.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше рукоятей.',
          'Опуститесь в вис до полного выпрямления рук.',
        ],
        tips: ['Выбирайте ширину хвата, при которой подтягиваетесь плавно и без боли.'],
      },
    ],
    safetyNote:
      'Меняйте хват только после схода со снаряда. Не используйте неудобный или болезненно широкий хват.',
  },
  {
    ...TRAINER_MODELS.benchPress,
    id: 'spl-18',
    categorySlug: 'sport-platforms',
    number: '18',
    photos: ['/equipment/sport-platforms/18. Жим лежа.webp'],
  },
  {
    ...TRAINER_MODELS.ellipticalTrainer,
    id: 'spl-19',
    categorySlug: 'sport-platforms',
    number: '19',
    photos: ['/equipment/sport-platforms/19. Эллиптический.webp'],
  },
  {
    ...TRAINER_MODELS.seatedRow,
    id: 'spl-20',
    categorySlug: 'sport-platforms',
    number: '20',
    photos: ['/equipment/sport-platforms/20. Рычажная тяга.webp'],
  },
  {
    ...TRAINER_MODELS.gravitron,
    id: 'spl-21',
    categorySlug: 'sport-platforms',
    number: '21',
    photos: ['/equipment/sport-platforms/21. Гравитрон.webp'],
  },
  {
    ...TRAINER_MODELS.cycleElliptical,
    id: 'spl-23',
    categorySlug: 'sport-platforms',
    number: '23',
    photos: ['/equipment/sport-platforms/23. Велоорбитрек.webp'],
  },
  {
    ...TRAINER_MODELS.hyperextension,
    id: 'spl-24',
    categorySlug: 'sport-platforms',
    number: '24',
    photos: ['/equipment/sport-platforms/24. Гиперэкстензия.webp'],
  },
  {
    id: 'spl-25',
    categorySlug: 'sport-platforms',
    number: '25',
    title: 'Шведская стенка с баскетбольным щитом и кольцом',
    description:
      'Гимнастическая стенка с баскетбольным щитом и кольцом. Позволяет выполнять упражнения у перекладин и отдельно тренировать точность бросков в кольцо.',
    photos: ['/equipment/sport-platforms/25. Шведская стенка с баскет щитом и кольцо.webp'],
    videoUrl: 'https://rutube.ru/play/embed/8e83b1d1bcd019648406f8b1f7877660',
    videoTitle: 'Подъём ног в висе на шведской стенке',
    specs: [
      { label: 'Высота', value: '2 800 мм' },
      { label: 'Перекладин', value: '12 шт.' },
      { label: 'Диаметр кольца', value: '450 мм' },
      { label: 'Размер щита', value: '900 × 600 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Подъём ног в висе на шведской стенке',
        inVideo: true,
        start:
          'Встаньте спиной к стенке, возьмитесь за верхнюю перекладину и повисните на прямых руках.',
        steps: [
          'Поднимите ноги вперёд — согнутые в коленях или прямые, если хватает силы.',
          'Медленно опустите ноги, не раскачиваясь.',
        ],
        tips: [
          'Начинайте с согнутых ног — это легче.',
          'Поднимайте ноги усилием мышц живота, без маха.',
        ],
      },
      {
        title: 'Броски мяча в кольцо',
        start: 'Встаньте лицом к кольцу, мяч в руках на уровне груди.',
        steps: [
          'Согните ноги и одновременно с их выпрямлением выбросите мяч вверх в кольцо.',
          'После броска дождитесь, пока мяч упадёт, и только затем подходите к щиту.',
        ],
      },
    ],
    safetyNote: 'Не висите на кольце и щите. Не бросайте мяч, когда на стенке кто-то занимается.',
  },
  {
    id: 'spl-26',
    categorySlug: 'sport-platforms',
    number: '26',
    title: 'Спортивный комплекс',
    description:
      'Комбинированный снаряд с верхней перекладиной, наклонными опорами и скамьёй. Объединяет несколько зон для упражнений с собственным весом и подготовки к подтягиваниям.',
    photos: ['/equipment/sport-platforms/26. Спортивный комплекс.webp'],
    specs: [
      { label: 'Длина', value: '6 000 мм' },
      { label: 'Высота', value: '2 400 мм' },
      { label: 'Секции', value: 'Рукоход, кольца, лестница, турники' },
      { label: 'Стойки', value: 'Труба 89 мм, Ст3' },
      { label: 'Покрытие', value: 'Порошковое, антивандальное' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    exercises: [
      {
        title: 'Подтягивание на перекладине',
        start: 'Вис на перекладине хватом сверху на ширине плеч, руки и ноги прямые.',
        steps: [
          'Подтянитесь, пока подбородок не окажется выше перекладины.',
          'Опуститесь в вис до полного выпрямления рук.',
        ],
        tips: ['Без рывков, махов ногами и раскачивания.'],
      },
      {
        title: 'Вис на перекладине',
        start:
          'Возьмитесь за перекладину хватом сверху на ширине плеч и повисните на прямых руках.',
        steps: [
          'Слегка напрягите плечи, чтобы они не уходили к ушам, ноги держите вместе.',
          'Удерживайте неподвижный вис без раскачивания.',
          'Сойдите со снаряда раньше, чем начнёт ослабевать хват.',
        ],
        tips: ['Хорошая подготовка к подтягиваниям и тренировка хвата.'],
      },
    ],
    safetyNote:
      'Не используйте конструктивные связи как ступени. Не занимайтесь на соседних элементах, если ваши зоны движения пересекаются.',
  },
  {
    id: 'spl-27',
    categorySlug: 'sport-platforms',
    number: '27',
    title: 'П-образный рукоход «Змейка»',
    description:
      'Рукоход с волнообразной перекладиной между опорами. Предназначен для висов и последовательного перемещения на руках с тренировкой хвата и координации.',
    photos: ['/equipment/sport-platforms/27. П-образный рукоход Змейка.webp'],
    specs: [
      { label: 'Высота', value: '2 400 мм' },
      { label: 'Длина пролёта', value: '2 500 мм' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Стойки', value: 'Труба 76 мм, Ст3' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/d039311950e273ea2c43bd447023b9aa',
    videoTitle: 'Передвижение по рукоходу «Змейка»',
    exercises: [
      {
        title: 'Передвижение на руках по рукоходу',
        inVideo: true,
        start: 'Возьмитесь за начало перекладины и повисните на прямых руках.',
        steps: [
          'Переставляйте руки по очереди вдоль перекладины, проверяя каждый хват.',
          'Пройдите рукоход до конца и спокойно сойдите.',
        ],
        tips: ['Двигайтесь без раскачивания.', 'Если устали, сойдите, не дожидаясь срыва хвата.'],
      },
      {
        title: 'Вис на перекладине',
        start:
          'Возьмитесь за перекладину хватом сверху на ширине плеч и повисните на прямых руках.',
        steps: [
          'Слегка напрягите плечи, чтобы они не уходили к ушам, ноги держите вместе.',
          'Удерживайте неподвижный вис без раскачивания.',
          'Сойдите со снаряда раньше, чем начнёт ослабевать хват.',
        ],
        tips: ['Хорошая подготовка к подтягиваниям и тренировка хвата.'],
      },
    ],
    safetyNote: 'Не двигайтесь навстречу другому человеку на рукоходе.',
  },
  {
    id: 'spl-28',
    categorySlug: 'sport-platforms',
    number: '28',
    title: 'Рукоход',
    description:
      'Рукоход с участками разной высоты и дополнительными подвесными элементами. Используется для передвижения на руках, висов и упражнений на силу хвата.',
    photos: ['/equipment/sport-platforms/28. Рукоход.webp'],
    specs: [
      { label: 'Длина', value: '3 600 мм' },
      { label: 'Высота', value: '2 100 / 2 400 мм' },
      { label: 'Диаметр перекладины', value: '34 мм' },
      { label: 'Стойки', value: 'Труба 76 мм, Ст3' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/4a3cf31735949a9fe0b17aafe177696b',
    videoTitle: 'Подтягивания и передвижение по рукоходу',
    exercises: [
      {
        title: 'Передвижение на руках по рукоходу',
        inVideo: true,
        start: 'Возьмитесь за первую перекладину и повисните на прямых руках.',
        steps: [
          'Переносите руки по очереди на соседние перекладины.',
          'Пройдите рукоход до конца и спокойно сойдите.',
        ],
        tips: ['Начинайте с участка, удобного по высоте.', 'Двигайтесь без раскачивания.'],
      },
      {
        title: 'Вис на перекладине',
        start:
          'Возьмитесь за перекладину хватом сверху на ширине плеч и повисните на прямых руках.',
        steps: [
          'Слегка напрягите плечи, чтобы они не уходили к ушам, ноги держите вместе.',
          'Удерживайте неподвижный вис без раскачивания.',
          'Сойдите со снаряда раньше, чем начнёт ослабевать хват.',
        ],
        tips: ['Хорошая подготовка к подтягиваниям и тренировка хвата.'],
      },
    ],
    safetyNote: 'Упражнения на кольцах и подвесных элементах осваивайте с инструктором.',
  },
  {
    id: 'spl-29',
    categorySlug: 'sport-platforms',
    number: '29',
    title: 'Пресс-брусья',
    description:
      'Станция с опорами для предплечий и брусьями для упражнений на пресс и плечевой пояс. Позволяет выполнять подъёмы согнутых ног и отжимания в упоре.',
    photos: ['/equipment/sport-platforms/29. Пресс-брусья.webp'],
    specs: [
      { label: 'Высота', value: '2 200 мм' },
      { label: 'Ширина хвата брусьев', value: '560 мм' },
      { label: 'Диаметр трубы', value: '48 мм' },
      { label: 'Материал', value: 'Ст3, порошковое окрашивание' },
      { label: 'Макс. нагрузка', value: '150 кг' },
      { label: 'Гарантия', value: '5 лет' },
    ],
    videoUrl: 'https://rutube.ru/play/embed/8a1270729175807b2bc25373eb1e2652',
    videoTitle: 'Отжимания на брусьях и подъём ног',
    exercises: [
      {
        title: 'Отжимания на брусьях',
        inVideo: true,
        start: 'Упор на прямых руках на рукоятях, спиной к спинке, корпус вертикально.',
        steps: [
          'Согните руки, опуская корпус, пока плечо не окажется примерно на уровне локтя.',
          'Выпрямите руки, поднимая корпус в упор.',
        ],
        tips: ['Не опускайтесь глубже, чем позволяет подвижность плеч.'],
      },
      {
        title: 'Подъём согнутых ног с опорой на предплечья',
        inVideo: true,
        start:
          'Поставьте предплечья на опоры, возьмитесь за рукояти, спина прижата к спинке, ноги свободно висят.',
        steps: [
          'Плавно поднимите согнутые колени к груди.',
          'Медленно опустите ноги, не раскачиваясь.',
        ],
        tips: ['Поднимайте ноги усилием мышц живота, без маха.'],
      },
    ],
    safetyNote: 'Переходите от одного упражнения к другому только после схода со снаряда.',
  },
  {
    ...TRAINER_MODELS.exerciseBike,
    id: 'spl-30',
    categorySlug: 'sport-platforms',
    number: '30',
    photos: ['/equipment/sport-platforms/30. Велотренажер.webp'],
  },
  {
    ...TRAINER_MODELS.shoulderPress,
    id: 'spl-31',
    categorySlug: 'sport-platforms',
    number: '31',
    photos: ['/equipment/sport-platforms/31. Жим вверх.webp'],
  },
];
